var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-toolbar',[_c('ion-buttons',_vm._l((_vm.topNodes),function(node,index){return _c('ion-button',{key:index,on:{"click":ev => _vm.onClick(ev, node)}},[_vm._v(" "+_vm._s(_vm.menuLabel(node))+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }